import React from "react";

import { FileCrossIcon, POIIcon } from "@/assets/icons";
import { MaskIcon } from "@/components/ui/MaskIcon";
import { cn } from "@/lib/utils";
import { PoiIndustry } from "@/types/poiParameter";

interface PoiGroupListProps {
  currentIndustry?: PoiIndustry;
  activeGroup: string;
  setActiveGroup: (groupId: string) => void;
}

export const PoiGroupList: React.FC<PoiGroupListProps> = ({
  currentIndustry,
  activeGroup,
  setActiveGroup
}) => {
  const groups = (currentIndustry?.poi_groups || []).sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <div className="w-[250px] flex-none flex flex-col gap-2 border-r border-gray-200 pr-4 pb-4 overflow-y-auto mt-3">
      <h4 className="text-sm font-semibold text-gray-900 font-plus-jakarta mb-1">
        Group
      </h4>
      {!groups.length ? (
        <div className="text-sm text-center flex flex-col items-start justify-center gap-1 px-2 py-4 h-full w-full">
          <div className="w-full flex items-center justify-center">
            <FileCrossIcon className="w-6 h-6 fill-light-gray" />
          </div>
          <p className="font-semibold text-txtBody w-full">
            No group available
          </p>
          <p className="text-xs text-txtPlaceholder w-full">
            There are no POI groups for the selected country or filter. Try
            changing the filter or contact your administrator.
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-0.5">
          {groups.map(({ code, name, icon_url }) => {
            const isActive = activeGroup === code;
            return (
              <button
                key={code}
                onClick={() => setActiveGroup(code)}
                title={name}
                className={cn(
                  "w-full text-left p-2 rounded-lg flex items-center gap-2 transition-colors font-plus-jakarta text-sm font-semibold",
                  isActive
                    ? "bg-[#E6F4F2] text-[#088C7A]"
                    : "text-gray-600 hover:bg-gray-50"
                )}
              >
                <span className="w-6 h-6 flex items-center justify-center shrink-0">
                  {icon_url ? (
                    <MaskIcon
                      url={icon_url}
                      className={cn(
                        "w-6 h-6",
                        isActive ? "text-teal-500" : "text-dim-gray"
                      )}
                    />
                  ) : (
                    <POIIcon
                      className={cn(
                        "w-6 h-6",
                        isActive ? "fill-teal-500" : "fill-dim-gray"
                      )}
                    />
                  )}
                </span>
                <span className="truncate">{name}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
